"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentWrapper = exports.ComponentVideo = exports.ComponentBorder = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ONE_PIXEL = 0.0625; // 1/16th of 1em : 1em = 16px

function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
}

var getBorderWidth = function getBorderWidth(borderWidth) {
  return borderWidth ? "".concat(borderWidth, "px") : '1px';
};

var ComponentWrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n\n    background-color: ", ";\n    background-image: ", ";\n    background-position: ", ";\n    background-size: ", ";\n    background-repeat: ", ";\n\n    padding-top: ", "em;\n    padding-right: ", "em;\n    padding-bottom: ", "em;\n    padding-left: ", "em;\n\n    margin-top: ", "em;\n    margin-bottom: ", "em;\n\n    /* prevent margin indenting single column items */\n    margin-right: 0em;\n    margin-left: 0em;\n\n    @media all and (min-width: 768px) {\n        margin-top: ", "em;\n\n        margin-right: ", "em;\n        margin-left: ", "em;\n\n        padding-top: ", "em;\n        padding-right: ", "em;\n        padding-bottom: ", "em;\n        padding-left: ", "em;\n    }\n\n    border-top-width: ", ";\n    border-top-style: ", ";\n    border-top-color: ", ";\n\n    border-bottom-width: ", ";\n    border-bottom-style: ", ";\n    border-bottom-color: ", ";\n\n    border-left-width: ", ";\n    border-left-style: ", ";\n    border-left-color: ", ";\n\n    border-right-width: ", ";\n    border-right-style: ", ";\n    border-right-color: ", ";\n\n    overflow: ", ";\n\n    box-shadow: ", ";\n\n    &.zoom {\n        transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;\n        box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.25);\n        transform: translateZ(0);\n        backface-visibility: none;\n\n        &:hover {\n            transform: scale(1.05);\n            box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.25);\n        }\n    }\n"])), function (props) {
  return "".concat(props.backgroundColor ? hexToRGB(props.backgroundColor, props.backgroundColorOpacity) : '');
}, function (props) {
  return props.backgroundImage ? "url(".concat(props.backgroundImage, ")") : null;
}, function (props) {
  return props.backgroundPosition;
}, function (props) {
  return props.backgroundSize;
}, function (props) {
  return props.backgroundRepeat || 'no-repeat';
}, function (props) {
  var _props$padding, _props$padding2;

  return (props.paddingMobile ? (((_props$padding = props.padding) === null || _props$padding === void 0 ? void 0 : _props$padding.top) || 0) / 2 : ((_props$padding2 = props.padding) === null || _props$padding2 === void 0 ? void 0 : _props$padding2.top) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding3, _props$padding4;

  return (props.paddingMobile ? (((_props$padding3 = props.padding) === null || _props$padding3 === void 0 ? void 0 : _props$padding3.right) || 0) / 2 : ((_props$padding4 = props.padding) === null || _props$padding4 === void 0 ? void 0 : _props$padding4.right) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding5, _props$padding6;

  return (props.paddingMobile ? (((_props$padding5 = props.padding) === null || _props$padding5 === void 0 ? void 0 : _props$padding5.bottom) || 0) / 2 : ((_props$padding6 = props.padding) === null || _props$padding6 === void 0 ? void 0 : _props$padding6.bottom) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding7, _props$padding8;

  return (props.paddingMobile ? (((_props$padding7 = props.padding) === null || _props$padding7 === void 0 ? void 0 : _props$padding7.left) || 0) / 2 : ((_props$padding8 = props.padding) === null || _props$padding8 === void 0 ? void 0 : _props$padding8.left) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$margin;

  return (((_props$margin = props.margin) === null || _props$margin === void 0 ? void 0 : _props$margin.top) > 0 ? props.margin.top : 0) * ONE_PIXEL;
}, function (props) {
  var _props$margin2;

  return (((_props$margin2 = props.margin) === null || _props$margin2 === void 0 ? void 0 : _props$margin2.bottom) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$margin3;

  return (((_props$margin3 = props.margin) === null || _props$margin3 === void 0 ? void 0 : _props$margin3.top) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$margin4;

  return (((_props$margin4 = props.margin) === null || _props$margin4 === void 0 ? void 0 : _props$margin4.right) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$margin5;

  return (((_props$margin5 = props.margin) === null || _props$margin5 === void 0 ? void 0 : _props$margin5.left) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding9;

  return (((_props$padding9 = props.padding) === null || _props$padding9 === void 0 ? void 0 : _props$padding9.top) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding10;

  return (((_props$padding10 = props.padding) === null || _props$padding10 === void 0 ? void 0 : _props$padding10.right) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding11;

  return (((_props$padding11 = props.padding) === null || _props$padding11 === void 0 ? void 0 : _props$padding11.bottom) || 0) * ONE_PIXEL;
}, function (props) {
  var _props$padding12;

  return (((_props$padding12 = props.padding) === null || _props$padding12 === void 0 ? void 0 : _props$padding12.left) || 0) * ONE_PIXEL;
}, function (props) {
  return ['top', 'both'].includes(props.borderY) ? getBorderWidth(props.borderWidth) : 0;
}, function (props) {
  return props.borderStyle || 'solid';
}, function (props) {
  return props.borderColor || 'rgba(0,0,0,0.1)';
}, function (props) {
  return ['bottom', 'both'].includes(props.borderY) ? getBorderWidth(props.borderWidth) : 0;
}, function (props) {
  return props.borderStyle || 'solid';
}, function (props) {
  return props.borderColor || 'rgba(0,0,0,0.1)';
}, function (props) {
  return ['left', 'both'].includes(props.borderX) ? getBorderWidth(props.borderWidth) : 0;
}, function (props) {
  return props.borderStyle || 'solid';
}, function (props) {
  return props.borderColor || 'rgba(0,0,0,0.1)';
}, function (props) {
  return ['right', 'both'].includes(props.borderX) ? getBorderWidth(props.borderWidth) : 0;
}, function (props) {
  return props.borderStyle || 'solid';
}, function (props) {
  return props.borderColor || 'rgba(0,0,0,0.1)';
}, function (props) {
  return props.backgroundMode === 3 ? 'hidden' : 'visible';
}, function (props) {
  var _props$theme;

  return props.boxShadow ? (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.boxShadow) || '0 0 10px 1px rgba(0, 0, 0, 0.25)' : 'none';
});

exports.ComponentWrapper = ComponentWrapper;

var ComponentBorder = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    border-width: 0px;\n    border-style: none;\n    border-color: ", ";\n    pointer-events: none;\n"])), function (props) {
  return props.highlight ? props.isLayoutPlugin ? 'red' : 'blue' : '#c3c3c3';
});

exports.ComponentBorder = ComponentBorder;

var ComponentVideo = _styled["default"].video(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    z-index: 0;\n\n    + div {\n        position: inherit;\n    }\n"])));

exports.ComponentVideo = ComponentVideo;